<template>
    <div class="special-attention">
        <b-card no-body>
            <b-card-header class="py-2 px-3">
                <!-- <h3 class="mb-0">Special Attention Account (SAA)</h3> -->
                   <b-row align-v="center">
                    <b-col cols="6">
                        <h3 class="mb-0">
                           Special Attention Account (SAA)
                        </h3>
                    </b-col>
                    <b-col cols="6" class="text-right">
                        <b-link href="javascript:void(0)" @click="modals.show_special_att_full_view = true">
                            <b-icon icon="eye-fill" variant="primary"></b-icon>
                            Full View
                        </b-link>
                    </b-col>
                </b-row>  
            </b-card-header>
            <div v-if="tableData.length > 0" class="rounded-bottom">
                <el-table
                :data="tableData"
                show-summary
                :summary-method="getSummaries"
                style="width: 100%">
                    <el-table-column
                        prop="commitment_approved_date"
                        label="Detected Status"
                        min-width="150"
                        width="auto">
                        <template slot="header" slot-scope="scope">
                            <span class="text-break">{{ scope.column.label }}</span>
                        </template>
                        <template slot-scope="scope">
                            <p class="top-line">{{ scope.row.commitment_approved_date }}</p>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="commitment_loan_statue"
                        label="Facility"
                        min-width="150"
                        width="auto">
                        <template slot="header" slot-scope="scope">
                            <span class="text-break">{{ scope.column.label }}</span>
                        </template>
                        <template slot-scope="{row}">
                            <p class="top-line">{{ row.commitment_is_manual == 1 ? row.commitment_loan_statue : row.commitment_sub_items[0].commitment_loan_statue }}</p>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="commitment_is_special_attention"
                        label="Detected A/C No."
                        min-width="150"
                        width="auto">
                        <template slot="header" slot-scope="scope">
                            <span class="text-break">{{ scope.column.label }}</span>
                        </template>
                        <template slot-scope="scope">
                            <p class="top-line">{{ scope.row.commitment_is_special_attention }}</p>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div v-else class="bg-light p-3 text-center rounded-bottom">
                <p class="text-xs">No SAA recorded</p>
            </div>
        </b-card>
         <SpecialAttentionModal
            :special-attention="specialAttention" 
            :special-attention-resp="specialAttentionResp"
            :show_special_att_full_view.sync="modals.show_special_att_full_view"
          />
    </div>
</template>
<script>
    import { Table, TableColumn } from 'element-ui'
    import SpecialAttentionModal from '@/views/CustomerProfile/CustomerModals/SpecialAttentionModal.vue'

    export default {
        name: 'special-attention',
        props: ['special-attention',
            'specialAttentionResp'
        ],
        components: {
            SpecialAttentionModal,
            [Table.name]: Table,
            [TableColumn.name]: TableColumn,
        },
        data() {
            return {
                tableData: this.specialAttention,
                modals: {
                  show_special_att_full_view: false
                }
            }
        },
        computed: {
            groupedCommitments() {
                const unique = [];
                for (const commitment of this.tableData) {
                    const existing = unique.find(
                        (c) => c.commitment_capacity === commitment.commitment_capacity && c.commitment_loan_statue === commitment.commitment_loan_statue
                    );
                    if (existing) {
                        existing.accountNumbers += 1;
                    } else {
                        unique.push({
                            commitment_capacity: commitment.commitment_capacity,
                            commitment_loan_statue: commitment.commitment_loan_statue,
                            accountNumbers: 1,
                        });
                    }
                }
                return unique;
            }
        },
        methods: {
            getSummaries(param) {
                const { columns, data } = param;
                const sums = [];
                columns.forEach((column, index) => {
                    if (index === 1) {
                        sums[index] = 'Total';
                        return;
                    } else if (index === 2) {
                        const values = data.map(item => Number(item[column.property]));
                        if (!values.every(value => isNaN(value))) {
                            sums[index] = values.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return prev + curr;
                            } else {
                                return prev;
                            }
                            }, 0);
                        } else {
                            sums[index] = 'N/A';
                        }
                    }
                });

                return sums;
            }
        }
    }
</script>